import { useCallback, useState } from "react"
import { Box, Link, Stack, Tooltip, Typography } from "@mui/material"
import { useUserSession } from "features/session/context"

type MailAddressProps = {
  address: string
  mailStatus: string | undefined
}
export const MailAddress = ({
  address,
  mailStatus
}: MailAddressProps) => {
  const { isAdmin } = useUserSession()
  const [isOpenTip, setIsOpenTip] = useState(false)
  const onClickCopy = useCallback(
    (text: string) => {
      navigator.clipboard.writeText(text)
      .then(() => {
        setIsOpenTip(true)
        setTimeout(() => {
          setIsOpenTip(false)
        }, 2000)
      })
    },
    []
  )
  return mailStatus === 'OK' ? (
    <Box>
      {isAdmin ? (
        <Tooltip
          open={isOpenTip}
          arrow
          title="Copy完了!"
          placement="top"
        >
          <Link variant="body2" underline="hover" onClick={(e) => { e.preventDefault(); onClickCopy(address) }}>
            {address}
          </Link>
        </Tooltip>
      ) : (
        <Typography variant="body2" color='text.primary' component="span">
          {address}
        </Typography>
      )}
    </Box>
  ) : (
    <Stack direction='row' alignItems="center" justifyContent="flex-start" spacing={1}>
      <Typography variant="body2" color='text.disabled' component="span">
        {address}
      </Typography>
      <Typography variant="caption" color='text.disabled' component="span">
        [{mailStatus}]
      </Typography>
    </Stack>
  )
}
